<template>
  <div class="user_left_menu">
    <div class="wrap pr">
      <div class="image">
        <img :src="user_info.avatar" alt class="pic_full" />
      </div>
      <p class="name">{{user_info.name}}</p>
      <p class="money">
        <span class="icon">
          <img src="../../assets/image/user_center/icon (5).png" alt class="pic_full" />
        </span>
        <span class="course_type">英语</span>
        <span class="icon dif">
          <img src="../../assets/image/user_center/icon (12).png" alt class="pic_full" />
        </span>
        <span class="course_type">{{user_info.coins}}</span>
      </p>
      <div class="free_notice" v-if="user_info.free_course > 0">体验课<span class="dif">{{user_info.free_course}}</span>节 <span class="dif hand_point" @click="$router.push('/search-teacher')">立即预约</span></div>
      <div class="divider"></div>
      <div class="item" @mouseover="active_this(0)" @mouseout="active_this(original_index)">
        <router-link to="/user/course">
          <span class="icon" v-if="active_menu_index != 0">
            <img src="../../assets/image/user_center/icon (13).png" alt class="pic_full" />
          </span>
          <span class="icon" v-if="active_menu_index == 0">
            <img src="../../assets/image/user_center/icon_hover (4).png" alt class="pic_full" />
          </span>
          <span :class="active_menu_index == 0 ? 'menu_name active':'menu_name'">我的课程</span>
        </router-link>
      </div>
      <div class="item" @mouseover="active_this(1)" @mouseout="active_this(original_index)">
        <router-link to="/user-center-teacher">
          <span class="icon" v-if="active_menu_index != 1">
            <img src="../../assets/image/user_center/icon (3).png" alt class="pic_full" />
          </span>
          <span class="icon" v-if="active_menu_index == 1">
            <img src="../../assets/image/user_center/icon_hover (5).png" alt class="pic_full" />
          </span>
          <span :class="active_menu_index == 1 ? 'menu_name active':'menu_name'">我的老师</span>
        </router-link>
      </div>
      <div class="item" @mouseover="active_this(2)" @mouseout="active_this(original_index)">
        <router-link to="/user-center-course">
          <span class="icon" v-if="active_menu_index != 2">
            <img src="../../assets/image/user_center/icon (11).png" alt class="pic_full" />
          </span>
          <span class="icon" v-if="active_menu_index == 2">
            <img src="../../assets/image/user_center/icon_hover (3).png" alt class="pic_full" />
          </span>
          <span :class="active_menu_index == 2 ? 'menu_name active':'menu_name'">教材推荐</span>
        </router-link>
      </div>
      <div class="divider"></div>
      <div class="item" @mouseover="active_this(3)" @mouseout="active_this(original_index)">
        <router-link to="/user-center-rights">
          <span class="icon" v-if="active_menu_index != 3">
            <img src="../../assets/image/user_center/icon (6).png" alt class="pic_full" />
          </span>
          <span class="icon" v-if="active_menu_index == 3">
            <img src="../../assets/image/user_center/icon_hover (10).png" alt class="pic_full" />
          </span>
          <span :class="active_menu_index == 3 ? 'menu_name active':'menu_name'">会员权限</span>
        </router-link>
      </div>
      <div class="item" @mouseover="active_this(4)" @mouseout="active_this(original_index)">
        <router-link to="/user-center-buy">
          <span class="icon" v-if="active_menu_index != 4">
            <img src="../../assets/image/user_center/icon (10).png" alt class="pic_full" />
          </span>
          <span class="icon" v-if="active_menu_index == 4">
            <img src="../../assets/image/user_center/icon_hover (7).png" alt class="pic_full" />
          </span>
          <span :class="active_menu_index == 4 ? 'menu_name active':'menu_name'">购买学币</span>
        </router-link>
      </div>
      <div class="item" @mouseover="active_this(5)" @mouseout="active_this(original_index)">
        <router-link to="/user-center-order">
          <span class="icon" v-if="active_menu_index != 5">
            <img src="../../assets/image/user_center/icon (21).png" alt class="pic_full" />
          </span>
          <span class="icon" v-if="active_menu_index == 5">
            <img src="../../assets/image/user_center/icon_hover (9).png" alt class="pic_full" />
          </span>
          <span :class="active_menu_index == 5 ? 'menu_name active':'menu_name'">订单管理</span>
        </router-link>
      </div>
      <div class="divider"></div>
      <div class="item" @mouseover="active_this(6)" @mouseout="active_this(original_index)">
        <router-link to="/user-center-info">
          <span class="icon" v-if="active_menu_index != 6">
            <img src="../../assets/image/user_center/icon (9).png" alt class="pic_full" />
          </span>
          <span class="icon" v-if="active_menu_index == 6">
            <img src="../../assets/image/user_center/icon_hover (1).png" alt class="pic_full" />
          </span>
          <span :class="active_menu_index == 6 ? 'menu_name active':'menu_name'">基本资料</span>
        </router-link>
      </div>
      <div class="item" @mouseover="active_this(7)" @mouseout="active_this(original_index)">
        <router-link to="/user-center-pwd">
          <span class="icon" v-if="active_menu_index != 7">
            <img src="../../assets/image/user_center/icon (4).png" alt class="pic_full" />
          </span>
          <span class="icon" v-if="active_menu_index == 7">
            <img src="../../assets/image/user_center/icon_hover (6).png" alt class="pic_full" />
          </span>
          <span :class="active_menu_index == 7 ? 'menu_name active':'menu_name'">修改密码</span>
        </router-link>
      </div>
      <div class="item" @mouseover="active_this(8)" @mouseout="active_this(original_index)">
        <router-link to="/user-center-msg">
          <span class="icon" v-if="active_menu_index != 8">
            <img src="../../assets/image/user_center/icon (8).png" alt class="pic_full" />
          </span>
          <span class="icon" v-if="active_menu_index == 8">
            <img src="../../assets/image/user_center/icon_hover (8).png" alt class="pic_full" />
          </span>
          <span :class="active_menu_index == 8 ? 'menu_name active':'menu_name'">短信提醒</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { common } from "../../../common.js";
export default {
  props: ["active_menu_index"],
  data: function() {
    return {
      original_index: "",
      user_info: ""
    };
  },
  mounted: function() {
    this.original_index = this._props.active_menu_index;
    this.get_info();
  },
  methods: {
    active_this(index) {
      this._props.active_menu_index = index;
    },
    get_info() {
      let self = this;
      common.requestFun(self, "get", "/student/profile", {}, res => {
        if (res.data.code == 200) {
          self.user_info = res.data.data;
        } else {
          if (res.data.msg && res.data.code == 401) {
            self.$message({
              message: "请登录",
              type: "error",
              center: true
            });
          }
          self.$router.push("./");
        }
      });
    }
  }
};
import "../../assets/css/common.css";
</script>
<style scoped src="./user_left_menu.css"></style>
